<style scoped>
	.c-panel{margin: 0px; padding: 0px 20px;}
</style>

<template>
	<el-dialog
		v-if="m"
		title="课程新建"
		:visible.sync="isShow"
		width="600px"
		top="25vh"
		:append-to-body="true"
		:destroy-on-close="true"
		:close-on-click-modal="false"
		custom-class="full-dialog"
		>
		<div class="vue-box">
			<div class="c-panel">
				<!-- 参数栏 -->
				<br>
				<el-form size="mini">
					<el-form-item label="开始时间：">
            <el-date-picker
                v-model="m.startTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择上课开始日期时间">
            </el-date-picker>
					</el-form-item>
          <el-form-item label="上课星期：">
              <el-checkbox-group v-model="m.week">
                <el-checkbox-button v-for="w in weekList" :label="w.id" :key="w.id">{{w.name}}</el-checkbox-button>
              </el-checkbox-group>
          </el-form-item>
          <el-form-item label="消耗课时：" v-show="m.status!=0">
            <el-input v-model="m.hour"></el-input>
          </el-form-item>
          <el-form-item label="课长(分钟)：" v-show="m.status!=0">
            <el-input v-model="m.length"></el-input>
          </el-form-item>
				</el-form>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="isShow = false">取 消</el-button>
			<el-button size="small" type="primary" @click="ok()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				isShow: true,
				id: 0,
				m: null,
        clazzInfo:{},
        teacherList:[],
        weekList:[
          {id:1,name:"周日"},
          {id:2,name:"周一"},
          {id:3,name:"周二"},
          {id:4,name:"周三"},
          {id:5,name:"周四"},
          {id:6,name:"周五"},
          {id:7,name:"周六"},
        ],
        cardList:[],
			}
		},
		methods: {
			// 打开
			open: function(id) {
          this.isShow = true;
          this.m = this.createM();
          this.sa.ajax('api/psdAdmin/clazz/getClazzInfoById', {id: id}, function(res) {
            this.clazzInfo = res.data;
            this.m.clazzId = res.data.id;
            console.log('班级信息',this.clazzInfo)
          }.bind(this), /*{res: this.getMockData(id)}*/);
			},
			// 表单验证
			submit_check: function() {
				var m = this.m;
				var sa = this.sa;
				if(sa.isNull(m.clazzId)) {
					return sa.error('班级ID丢失，你可以尝试重新从班级列表打开');
				}
        if(sa.isNull(m.startTime)) {
          return sa.error('请选择开始时间');
        }
        if(sa.isNull(m.week)) {
          return sa.error('你必须至少选择一个星期');
        }
        if(sa.isNull(m.hour)) {
          return sa.error('每节课消耗课时必须填写');
        }
        if(sa.isNull(m.length)) {
          return sa.error('每节课上课时长必须填写');
        }
				return 'ok';
			},
			// 提交
			ok: function() {
				// 表单验证
				if(this.submit_check() != 'ok') {
					return;
				}
				console.log('提交数据',this.m);

				// 开始增加或修改
				let self = this;
        // id != 0 为修改
        this.sa.ajax('api/psdAdmin/clazzCard/createClazzCard', JSON.stringify(this.m), function(res){
          if(res.code == '0') {
            self.sa.alert('重新创建课表成功', function () {
              self.$parent.f5();	// 父视图刷新
              self.isShow = false;
            });
          }else{
            this.sa.error(res.msg || '修改失败');
          }
        },{ contentType:"application/json;charset=UTF-8"});
      },
      createM:function (){
        return {
          clazzId:'',
          startTime:'',
          week:[],
          hour:'',
          length:''
        }
      }
		},
		created: function(){

		}
	}
</script>
